import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { UpsertEventGateForm, UpsertGatesForm } from "../../schemas";
import eventsQueryKeys from "../../query-keys/events.query-keys";

const upsertGates = async (data: UpsertGatesForm, eventId: string) => {
  const { data: response } = await privateAxios.post(
    `/events/${eventId}/gates`,
    data
  );
  return response;
};

export const useUpsertGatesMutation = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpsertGatesForm) => upsertGates(data, eventId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...eventsQueryKeys.get(eventId), "gates"],
      });
      queryClient.invalidateQueries({
        queryKey: eventsQueryKeys.get(eventId),
      });
    },
  });
};

const upsertEventGate = async (eventId: string, data: UpsertEventGateForm) => {
  const { data: response } = await privateAxios.post(
    `/events/${eventId}/gate`,
    data
  );
  return response;
};

export const useUpsertEventGateMutation = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpsertEventGateForm) => upsertEventGate(eventId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...eventsQueryKeys.get(eventId), "gates"],
      });
    },
  });
};

const deleteEventGate = async (eventId: string, gateId: string) => {
  const { data: response } = await privateAxios.delete(
    `/events/${eventId}/gates/${gateId}`
  );
  return response;
};

export const useDeleteEventGateMutation = (eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (gateId: string) => deleteEventGate(eventId, gateId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...eventsQueryKeys.get(eventId), "gates"],
      });
    },
  });
};
